import {Injectable} from '@angular/core';
import {HttpFilterParam} from 'prod-shared';
import {OrganizationService} from "./organization.service";

@Injectable({
  providedIn: 'root'
})
export class DistributorService extends OrganizationService {
  override getSelectFilters(): HttpFilterParam[] {
    return [];
  }
}
